const basePaths = {
    dev: '//localhost:1111/components',
    qa: '//qswebbdevwb6001.morningstar.com/components',
    uat: '//markets-uat.morningstar.com/components',
    stg: '//markets-uat.morningstar.com/components',
    stage: '//markets-uat.morningstar.com/components',
    prod: '//quotespeed.morningstar.com/components',
};

const mwcBasePaths = {
    dev: '//localhost',
    qa: '//mwc-cdn-qa.morningstar.com/components',
    uat: '//mwc-cdn-uat.morningstar.com/components',
    stg: '//mwc-cdn-staging.morningstar.com/components',
    stage: '//mwc-cdn-staging.morningstar.com/components',
    prod: '//mwc-cdn.morningstar.com/components',
};

const getBasePath = function getBasePath(environment, sourceType) {
    let basePath;
    if (sourceType === 'mwc') {
        basePath = mwcBasePaths[environment];
    } else if (sourceType === 'qs') {
        basePath = basePaths[environment];
    } else {
        throw new Error(`Specified CDN source type '${sourceType}' does not exist.`);
    }
    if (!basePath) {
        throw new Error(`Specified CDN environment '${environment}' does not exist.`);
    }
    return basePath;
};

const getBundleFiles = function getBundleFiles(environment, component, version, instid, sourceType) {
    // todo: remove the instid. However, we need a solution to solve the client special styles and dom
    if (component === 'angular') {
        return [`//ajax.googleapis.com/ajax/libs/angularjs/${version}/angular.min.js`];
    }
    const basePath = getBasePath(environment, sourceType);
    const filename = [basePath, component, version, instid, component].join('/');
    return [`${filename}-bundle.js`, `${filename}-bundle.css`];
};

const getLibraryBasePath = function getLibraryBasePath(environment, sourceType) {
    return getBasePath(environment, sourceType).replace('components', 'lib');
};

export {
    getBasePath,
    getBundleFiles,
    getLibraryBasePath,
};



// WEBPACK FOOTER //
// ./src/bundle-helper.js